module.exports = __webpack_public_path__ + "static/media/blue_night_short.b4121f27.svg";